export default __webpack_public_path__ + "static/media/square-gaba.8277489b.jpeg";